import { render, staticRenderFns } from "./InsLogo.vue?vue&type=template&id=94e1c03c&scoped=true"
import script from "./InsLogo.vue?vue&type=script&lang=ts"
export * from "./InsLogo.vue?vue&type=script&lang=ts"
import style0 from "./InsLogo.vue?vue&type=style&index=0&id=94e1c03c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e1c03c",
  null
  
)

export default component.exports